const CONSENT_KEY = "viwo_cookie_consent_minimal";
let isStarted = false;


function hasAnalyticsConsent() {
    return ["1", "accepted"].includes(localStorage.getItem(CONSENT_KEY));
}

function track(eventName, parameters = {}) {
    if (!isStarted || typeof window.gtag !== "function") return;
    window.gtag("event", eventName, parameters);
}

function bindInteractionTracking() {
    document.addEventListener("click", (event) => {
        const link = event.target.closest("a");
        if (!link) return;

        const href = link.getAttribute("href") || "";
        const linkText = (link.textContent || "").trim().replace(/\s+/g, " ").slice(0, 100);
        const pagePath = new URL(link.href || window.location.href, window.location.origin).pathname;

        if (href.startsWith("tel:")) {
            track("contact_click", { contact_method: "phone", link_text: linkText });
        } else if (href.startsWith("mailto:")) {
            track("contact_click", { contact_method: "email", link_text: linkText });
        } else if (link.classList.contains("language--picker")) {
            track("language_change", { target_language: link.textContent.trim().toLowerCase() });
        } else if (href.includes("/pdf")) {
            track("file_download", {
                file_extension: "pdf",
                file_name: pagePath.split("/").filter(Boolean).at(-2) || "tds"
            });
        } else if (link.classList.contains("tds-share__button") || href.includes("wa.me") || href.includes("twitter.com/intent")) {
            track("share", {
                method: link.classList.contains("tds-share__button--whatsapp") ? "whatsapp" : "x"
            });
        } else {
            const navigationArea = link.closest("header") ? "header" : link.closest("footer") ? "footer" : null;
            if (navigationArea) {
                track("navigation_click", {
                    navigation_area: navigationArea,
                    link_text: linkText,
                    destination_path: pagePath
                });
            }
        }
    });
}

function loadGa4(config) {
    if (isStarted || !config?.measurementId) return;
    isStarted = true;

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
        window.dataLayer.push(arguments);
    };

    window.gtag("js", new Date());
    window.gtag("config", config.measurementId, { send_page_view: false });

    track("page_view", {
        page_title: document.title,
        page_location: window.location.href,
        page_path: window.location.pathname,
        page_type: config.pageType || "general",
        site_language: config.culture || "tr"
    });

    if (config.conversionEvent) {
        track(config.conversionEvent, { page_type: config.pageType || "contact" });
    }

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(config.measurementId)}`;
    document.head.appendChild(script);

    bindInteractionTracking();
}

export function initAnalytics() {
    const config = window.AcranAnalyticsConfig;
    if (!config?.measurementId) return;

    if (hasAnalyticsConsent()) {
        loadGa4(config);
        return;
    }

    window.addEventListener("acran:analytics-consent", () => loadGa4(config), { once: true });
}
